import { TaxIdType, BranchType } from './types'

export const TAX = {
  THAI_TAX_ID_LENGTH: 13,
}

export const TAX_ID_CONFIG = [
  {
    value: TaxIdType.Thai,
    labelKey: 'form.companyTaxInvoice.taxIdTypeThai'
  },
  {
    value: TaxIdType.Foreign,
    labelKey: 'form.companyTaxInvoice.taxIdTypeForeign'
  },
]

export const BRANCH_CONFIG = [
  {
    value: BranchType.Headquarter,
    labelKey: 'form.companyTaxInvoice.branchHQ'
  },
  {
    value: BranchType.Branch,
    labelKey: 'form.companyTaxInvoice.branchBranch'
  },
  {
    value: BranchType.Unspecified,
    labelKey: 'form.companyTaxInvoice.branchUnspecified'
  },
]
